/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconEdit8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconEdit8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.371.879A1.05 1.05 0 0 1 6.636.878c.057.043.118.103.249.234.132.131.192.192.236.25.284.374.285.893.001 1.269a2.77 2.77 0 0 1-.235.25L2.799 6.97l-1.81.362-.321-.321.362-1.81 4.092-4.089c.131-.13.192-.191.25-.234ZM2.465 6.347 5.398 3.41l-.807-.808-2.937 2.933-.202 1.013 1.013-.202ZM6.408 2.4l-.482.482-.807-.808.483-.482c.067-.067.108-.108.14-.138a.373.373 0 0 1 .487-.035c-.002 0 .007.005.037.034a9.237 9.237 0 0 1 .28.28c.03.03.036.039.035.037a.374.374 0 0 1 0 .45c.001 0-.005.008-.034.039-.03.032-.072.073-.14.14Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconEdit12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconEdit12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.055 1.318a1.576 1.576 0 0 1 1.897-.001c.086.064.177.155.373.35.198.197.29.289.354.375.427.562.428 1.34.003 1.904a4.158 4.158 0 0 1-.354.375l-6.132 6.136L1.482 11 1 10.517l.543-2.715L7.682 1.67a4.15 4.15 0 0 1 .373-.352ZM3.695 9.52l4.4-4.404-1.21-1.212-4.405 4.4-.304 1.52 1.519-.304ZM9.61 3.6l-.723.723-1.21-1.211.723-.723.21-.208c.047-.044.06-.053.057-.051a.56.56 0 0 1 .674 0c-.002-.002.01.007.056.05.048.046.11.107.211.208.102.101.164.163.21.211a.56.56 0 0 1 .053.733c0-.002-.009.01-.052.056-.046.049-.108.11-.21.212Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconEdit16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconEdit16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.738 1.758a2.1 2.1 0 0 1 2.53-.002c.114.086.236.206.498.467.263.263.385.384.472.499.569.75.57 1.787.003 2.54-.087.114-.208.236-.47.499l-8.178 8.182-3.618.724-.643-.644.724-3.62 8.185-8.177c.262-.262.383-.382.497-.468ZM4.925 12.693l5.868-5.872-1.615-1.616-5.873 5.867-.405 2.026 2.025-.405ZM12.811 4.8l-.963.964-1.614-1.615.965-.964.28-.277c.062-.058.079-.07.076-.068.266-.2.632-.201.898 0-.003-.003.014.01.075.067.065.061.147.143.281.277.136.135.218.217.28.282.059.06.07.078.069.075a.747.747 0 0 1 0 .901c.003-.002-.01.015-.068.076-.061.065-.144.147-.279.282Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconEdit24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconEdit24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.11 2.636a3.151 3.151 0 0 1 3.794-.002c.171.129.354.31.747.701.395.394.578.576.708.748a3.157 3.157 0 0 1 .004 3.809c-.13.172-.312.355-.706.75L8.392 20.914 2.965 22 2 21.035l1.086-5.43L15.364 3.338c.392-.392.574-.573.745-.703ZM7.39 19.04l8.801-8.807-2.422-2.424-8.81 8.8-.607 3.039 3.038-.608ZM19.22 7.202l-1.446 1.446-2.42-2.422L16.8 4.78c.201-.202.325-.325.42-.416.092-.087.118-.106.114-.103.398-.3.948-.3 1.346 0-.004-.004.022.015.114.102.096.091.22.214.421.415.203.202.327.326.42.422.087.092.106.118.103.113.303.4.303.952.001 1.352.003-.004-.015.022-.103.114-.092.096-.216.22-.418.423Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconEdit = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconEdit(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconEdit8 {...iconProps} />;
        case '12':
            return <IconEdit12 {...iconProps} />;
        case '16':
            return <IconEdit16 {...iconProps} />;
        case '24':
            return <IconEdit24 {...iconProps} />;
        default:
            return <IconEdit24 {...iconProps} />;
    }
});
